import { render, staticRenderFns } from "./ExemptItems.vue?vue&type=template&id=6fbd4188&scoped=true&"
import script from "./ExemptItems.vue?vue&type=script&lang=js&"
export * from "./ExemptItems.vue?vue&type=script&lang=js&"
import style0 from "./ExemptItems.vue?vue&type=style&index=0&id=6fbd4188&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbd4188",
  null
  
)

export default component.exports